import React from 'react';
import { BACKEND_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import DiagnosticWizard from '../components/assessment/AssessmentDiagnostic';

const AssessmentWizard = () => {
  const navigate = useNavigate();
  const handleComplete = (result) => {
    // Navigate to the results dashboard with the assessment ID
    navigate(`/assessments/results/${result.scan_id}`);
  };
  return <DiagnosticWizard onComplete={handleComplete} />;
};
export default AssessmentWizard;
